import { useEffect } from 'react';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';

import { showModal, TYPES } from '../../actions/modal';
import { EFB_WHATS_NEW_STATE, useLocalStorage } from '../../hocs/useLocalStorage';
import { useIsAuthenticated } from '../../selectors/login';
import version from '../../service/whatsNew';

export const useWhatsNewModal = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const [value] = useLocalStorage(EFB_WHATS_NEW_STATE, {});

    useEffect(() => {
        if (isAuthenticated && version.showWhatsNew && !value[`${version.NUMBER}`]) {
            dispatch(
                showModal(TYPES.WHATS_NEW, {
                    title: t('whatsNew.whatsNew'),
                })
            );
        }
    }, [isAuthenticated, value]);
};
